import React, { Component } from "react";
import { FlagsProvider } from 'flag';
import SimilarTitlesCarouselContainer from "react/containers/SimilarTitlesCarouselContainer";
import SimilarAuthorsCarouselContainer from "react/containers/SimilarAuthorsCarouselContainer";
import SimilarSeriesCarouselContainer from "../containers/SimilarSeriesCarouselContainer";
import ReaderReviewsContainer from "../containers/ReaderReviewsContainer";
import ReadingLevelFeatureContainer from "../containers/ReadingLevelFeatureContainer";
import BookListsCarouselContainer from "react/containers/BookListsCarouselContainer";
import AttributionContainer from "react/containers/AttributionContainer";
import BookSummaryContainer from "react/containers/bookSummary/BookSummaryContainer";
import InsideThisBookContainer from "react/containers/InsideThisBookContainer"
import AuthorBioContainer from "react/containers/authorBiography/AuthorBioContainer"
import AcceleratedReaderFeatureContainer from '../containers/acceleratedReader/AcceleratedReaderFeatureContainer';
import ProfessionalReviewsContainer from '../containers/ProfessionalReviewsContainer';
import MoreAboutThisTitleContainer from '../containers/MoreAboutThisTitleContainer';
import LinkToBookChatContainer from "../containers/LinkToBookChatContainer";
import TitlesInSeriesContainer from "react/containers/TitlesInSeriesContainer";
import StoryFinderContainer from "react/containers/StoryFinderContainer";
import AboutThisBookContainer from '../containers/AboutThisBookContainer';
import { SkippableContent } from '@novelist/novum-novella-ui';

import "./card.less";
import "./CardSetV4.less";

class CardSetV4 extends Component {
	constructor(){
		super();
		this.numberOfLines = 10;
	}

	setCssParameters() {
		document.documentElement.style.setProperty('--novelist-card-border', '1px solid rgba(0,0,0,.175)');
		document.documentElement.style.setProperty('--novelist-card-border-radius', '6px');
		document.documentElement.style.setProperty('--novelist-font-family-normal', '"Noto Sans", "Open Sans", "Helvetica Neue", Arial, Helvetica, sans-serif');
		document.documentElement.style.setProperty('--novelist-font-family-bold', '"Noto Sans", "Open Sans", "Helvetica Neue", Arial, Helvetica, sans-serif');
		document.documentElement.style.setProperty('--novelist-card-title-font-size', '16px');
		document.documentElement.style.setProperty('--novelist-card-title-font-weight', 'bold');
		document.documentElement.style.setProperty('--novelist-card-title-padding', '10px');
		document.documentElement.style.setProperty('--novelist-card-title-color', 'rgba(216, 216, 216, 0.5)');
		document.documentElement.style.setProperty('--novelist-link-color', '#2D62B7');
		document.documentElement.style.setProperty('--novelist-card-footer-color', '#D8D8D8');
		document.documentElement.style.setProperty('--novelist-book-text-height', '170px');
	}

	render() {
		this.setCssParameters();

		return (
			<FlagsProvider flags={this.props.featureFlags}>
				<div>
					<SkippableContent skipTargetDisplayName="NoveList">
						<LinkToBookChatContainer />
						<TitlesInSeriesContainer />
						<SimilarTitlesCarouselContainer />
						<SimilarAuthorsCarouselContainer />
						<SimilarSeriesCarouselContainer />
						<BookListsCarouselContainer />
						<StoryFinderContainer />
						{this.props.featureFlags.aboutthisbookCarousel() ? 
							<AboutThisBookContainer featureFlags={this.props.featureFlags} numberOfLines={this.numberOfLines} /> 
							: 
							<div data-test-id="Ratings and reviews" className="tab-content-v4">
								<ReaderReviewsContainer uiVersionFlag={this.props.featureFlags.novelistSelectUiVersion()} />
								<ReadingLevelFeatureContainer />
								<AcceleratedReaderFeatureContainer />
								<ProfessionalReviewsContainer />
								<BookSummaryContainer numberOfLines={this.numberOfLines} />
								<AuthorBioContainer numberOfLines={this.numberOfLines} />
								<InsideThisBookContainer />
							</div>
						}
						<MoreAboutThisTitleContainer />
						<AttributionContainer />
					</SkippableContent>
				</div>
			</FlagsProvider>
		);
	}
}

export default CardSetV4;



// WEBPACK FOOTER //
// ./src/react/card/CardSetV4.jsx